import {
	getSharedAudioContext,
} from '@/common/functions/audioPlatform';

const playTone = (context, { frequency, start, duration, volume = 0.07, type = 'sine' }) => {
	const gain = context.createGain();
	const now = context.currentTime + start;

	gain.gain.setValueAtTime(0.0001, now);
	gain.gain.exponentialRampToValueAtTime(volume, now + 0.02);
	gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);
	gain.connect(context.destination);

	const oscillator = context.createOscillator();
	oscillator.type = type;
	oscillator.frequency.setValueAtTime(frequency, now);
	oscillator.connect(gain);
	oscillator.start(now);
	oscillator.stop(now + duration + 0.02);
};

export const playCallConnectSound = async () => {
	const context = await getSharedAudioContext();
	if (!context) {
		return;
	}

	playTone(context, { frequency: 520, start: 0, duration: 0.14, volume: 0.06 });
	playTone(context, { frequency: 780, start: 0.1, duration: 0.18, volume: 0.07 });
};

export const playCallEndSound = async () => {
	const context = await getSharedAudioContext();
	if (!context) {
		return;
	}

	playTone(context, {
		frequency: 587,
		start: 0,
		duration: 0.12,
		volume: 0.05,
		type: 'sine',
	});
	playTone(context, {
		frequency: 440,
		start: 0.13,
		duration: 0.2,
		volume: 0.045,
		type: 'sine',
	});
	playTone(context, {
		frequency: 330,
		start: 0.3,
		duration: 0.32,
		volume: 0.035,
		type: 'triangle',
	});
};
